import script from "./ProjectCounter.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectCounter.vue?vue&type=script&setup=true&lang=js"

import "./ProjectCounter.vue?vue&type=style&index=0&id=c49acc64&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c49acc64"]])

export default __exports__